var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI-Logo 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.39453 17.3766C2.61711 17.3767 3.83128 17.1808 4.98792 16.7969",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0588 3.65928C11.8097 2.818 11.4554 2.0094 11.0039 1.25146",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.6004 17.3755C19.9887 16.3503 19.2064 15.4302 18.2852 14.6523",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.6044 6.62695C19.382 6.62715 18.1681 6.82328 17.0117 7.20741",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.94922 20.3433C10.1983 21.1845 10.5526 21.9931 11.0041 22.7511",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.39453 6.62695C2.0062 7.65195 2.78822 8.57203 3.70906 9.35008",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.0005 17.3749C11.4871 16.5578 11.7433 15.631 11.7433 14.6876C11.7433 13.7442 11.4871 12.8174 11.0005 12.0003C10.514 11.1833 9.81408 10.5048 8.97128 10.0331C8.12847 9.56137 7.17242 9.31301 6.19922 9.31299",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.19922 14.6888C7.17242 14.6888 8.12847 14.4405 8.97128 13.9687C9.81408 13.497 10.514 12.8185 11.0005 12.0015C11.4871 11.1844 11.7433 10.2576 11.7433 9.31421C11.7433 8.37079 11.4871 7.44398 11.0005 6.62695",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.9835 8.71563C19.6113 8.08584 20.1575 7.3841 20.6098 6.62599C19.3713 5.05979 17.5875 3.98363 15.591 3.59811C13.5945 3.21259 11.5215 3.54401 9.75839 4.53061C7.99531 5.51721 6.66247 7.09165 6.00833 8.96045C5.35419 10.8292 5.42338 12.8649 6.203 14.6879C6.68962 13.8709 7.38951 13.1925 8.2323 12.7208C9.0751 12.2491 10.0311 12.0008 11.0043 12.0008C11.9775 12.0008 12.9335 12.2491 13.7763 12.7208C14.6191 13.1925 15.319 13.8709 15.8056 14.6879C14.566 16.2513 12.7828 17.3248 10.7876 17.7087C8.7925 18.0926 6.72144 17.7607 4.95992 16.7748C3.19839 15.7889 1.86639 14.2161 1.21184 12.3491C0.557285 10.4822 0.624762 8.4483 1.40171 6.62599C2.30399 6.62608 3.20289 6.73293 4.07846 6.94417",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.9215 17.0584C18.7978 17.2699 19.6974 17.3767 20.6004 17.3766C21.378 15.5541 21.4459 13.5198 20.7915 11.6524C20.137 9.78501 18.8048 8.21181 17.0429 7.22571C15.281 6.23961 13.2095 5.90782 11.214 6.29213C9.21851 6.67643 7.43511 7.75064 6.19582 9.31473C6.68245 10.1317 7.38233 10.8101 8.22512 11.2818C9.06792 11.7535 10.0239 12.0018 10.9971 12.0018C11.9703 12.0018 12.9263 11.7535 13.7691 11.2818C14.6119 10.8101 15.3118 10.1317 15.7984 9.31473C16.5753 11.137 16.6428 13.1709 15.9883 15.0379C15.3337 16.9048 14.0017 18.4776 12.2402 19.4635C10.4787 20.4495 8.40761 20.7814 6.41248 20.3975C4.41735 20.0136 2.63407 18.94 1.39453 17.3766C1.84686 16.6185 2.393 15.9168 3.02083 15.287",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.2795 19.4443C12.0442 20.6073 11.6121 21.7245 11.0006 22.7507C13.0173 22.4921 14.8684 21.5319 16.2092 20.0488C17.5501 18.5658 18.2893 16.6609 18.2893 14.6888C18.2893 12.7168 17.5501 10.8119 16.2092 9.32885C14.8684 7.84578 13.0173 6.88556 11.0006 6.62695C10.514 7.44398 10.2578 8.37079 10.2578 9.31421C10.2578 10.2576 10.514 11.1844 11.0006 12.0015C11.4872 12.8185 12.187 13.497 13.0298 13.9687C13.8726 14.4405 14.8287 14.6888 15.8019 14.6888",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.72149 4.55863C9.95644 3.39545 10.3883 2.27796 10.9996 1.25146C8.98289 1.51008 7.13182 2.47029 5.79099 3.95336C4.45016 5.43643 3.71094 7.3413 3.71094 9.31335C3.71094 11.2854 4.45016 13.1903 5.79099 14.6733C7.13182 16.1564 8.98289 17.1166 10.9996 17.3752C10.513 16.5582 10.2568 15.6314 10.2568 14.688C10.2568 13.7446 10.513 12.8177 10.9996 12.0007C11.4862 11.1837 12.186 10.5052 13.0288 10.0335C13.8717 9.56173 14.8277 9.31338 15.8009 9.31335",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.c61c841e8ebd4c10c550f4c95e49316c.svg";
export { ForwardRef as ReactComponent };